import React, { Fragment } from 'react';
import { CandidateResult, getMer, SYS_LABEL, SYS_CLS } from '../data/matrixData';
interface MatrixResultProps {
  result: CandidateResult[];
  selectedMeridians: string[];
}
export function MatrixResult({
  result,
  selectedMeridians
}: MatrixResultProps) {
  const n = selectedMeridians.length;
  const tm: Record<number, CandidateResult[]> = {};
  const to: number[] = [];
  result.forEach(r => {
    if (!tm[r.n]) {
      tm[r.n] = [];
      to.push(r.n);
    }
    tm[r.n].push(r);
  });
  to.sort((a, b) => b - a);
  return <div className="animate-fade" data-id="element-106">
      <div className="mb-4 md:mb-5 pb-3 md:pb-3.5 border-b border-border" data-id="element-107">
        <div className="font-serif text-[0.9rem] md:text-[1.05rem] font-bold text-ink mb-1.5 flex items-center flex-wrap gap-1.5 leading-[1.5]" data-id="element-108">
          Common meridian for:
          {selectedMeridians.map((a, i) => {
          const m = getMer(a);
          return <Fragment key={a} data-id="element-109">
                <span className="inline-flex items-center py-1 px-2 md:px-2.5 rounded-full text-[0.6rem] md:text-[0.7rem] font-bold font-sans bg-teal-p text-teal-l border border-teal-l/30 whitespace-nowrap" data-id="element-110">
                  {a}
                  {m ? ` — ${m.n}` : ''}
                </span>
                {i < selectedMeridians.length - 1 && <span className="text-muted text-[0.8rem]" data-id="element-111"> + </span>}
              </Fragment>;
        })}
        </div>
        <div className="text-[0.72rem] md:text-[0.78rem] text-muted italic" data-id="element-112">
          {result.length} candidate{result.length !== 1 ? 's' : ''} evaluated
          across all 5 balancing systems
        </div>
      </div>

      {to.map(cnt => {
      const grp = tm[cnt];
      const full = cnt === n;
      const high = !full && cnt >= Math.ceil(n * 0.6);
      let tc = '';
      if (full) tc = 'bg-teal text-white';else if (high) tc = 'bg-gold-d text-white';else tc = 'bg-bg3 text-ink3 border border-border';
      const tl = full ? `Covers All ${n} Meridians` : `Covers ${cnt} of ${n} Meridians`;
      return <div key={cnt} data-id="element-113">
            <div className="flex items-center gap-2 md:gap-2.5 my-4 md:my-6 mb-3" data-id="element-114">
              <span className={`text-[0.55rem] md:text-[0.6rem] font-extrabold tracking-[0.07em] uppercase py-1 px-2.5 md:px-3 rounded-full whitespace-nowrap shrink-0 ${tc}`} data-id="element-115">
                {tl}
              </span>
              <span className="flex-1 h-px bg-border" data-id="element-116"></span>
              <span className="text-[0.62rem] md:text-[0.68rem] text-muted italic whitespace-nowrap" data-id="element-117">
                {grp.length} meridian{grp.length !== 1 ? 's' : ''}
              </span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-[repeat(auto-fill,minmax(260px,1fr))] gap-3 md:gap-3.5 mb-1.5" data-id="element-118">
              {grp.map((r, i) => {
            const mi = getMer(r.mer);
            const best = cnt === to[0] && i === 0;
            return <div key={r.mer} className={`bg-white border rounded-[10px] overflow-hidden transition-all duration-150 ${best ? 'border-teal-l border-2 shadow-[0_2px_12px_rgba(30,100,100,0.16)] hover:shadow-[0_6px_22px_rgba(30,100,100,0.22)]' : 'border-border shadow-sm hover:shadow-md hover:-translate-y-0.5'}`} data-id="element-119">
                    <div className="bg-gradient-to-br from-bg3 to-bg2 py-2.5 px-3 md:py-3 md:px-4 flex items-center gap-2.5 md:gap-3 border-b border-border" data-id="element-120">
                      <div className="font-serif text-[1.5rem] md:text-[1.9rem] font-bold text-teal leading-none min-w-[40px] md:min-w-[50px]" data-id="element-121">
                        {r.mer}
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-122">
                        <div className="text-[0.8rem] md:text-[0.88rem] font-bold text-ink whitespace-nowrap overflow-hidden text-ellipsis" data-id="element-123">
                          {mi ? mi.n : r.mer}
                        </div>
                        <div className="text-[0.58rem] md:text-[0.64rem] text-muted mt-0.5" data-id="element-124">
                          {mi ? `${mi.l} · ${mi.f}` : ''}
                        </div>
                      </div>
                      <div className="flex gap-1 md:gap-1.5 shrink-0 items-center" data-id="element-125">
                        {best && <span className="text-[0.5rem] md:text-[0.54rem] font-extrabold tracking-[0.07em] uppercase bg-teal text-white py-1 px-1.5 md:px-2 rounded-md" data-id="element-126">
                            Best
                          </span>}
                        <span className="font-mono text-[0.56rem] md:text-[0.63rem] bg-white text-teal border border-border py-1 px-1.5 md:px-2 rounded-md whitespace-nowrap" data-id="element-127">
                          {r.n}/{n}
                          {r.ts ? ` · ${r.ts}sys` : ''}
                        </span>
                      </div>
                    </div>

                    <div className="py-2.5 px-3 md:py-3 md:px-4" data-id="element-128">
                      {r.covers.map(c => {
                  const sm = getMer(c.sick);
                  return <div key={c.sick} className="flex items-start gap-2 md:gap-2.5 py-1.5 md:py-2 border-b border-border last:border-b-0" data-id="element-129">
                            <div className="w-[24px] h-[24px] md:w-[26px] md:h-[26px] rounded-full bg-teal-p text-teal border border-teal/30 flex items-center justify-center text-[0.56rem] md:text-[0.62rem] font-extrabold shrink-0 mt-0.5" data-id="element-130">
                              {c.sick}
                            </div>
                            <div className="flex-1 min-w-0" data-id="element-131">
                              <div className="text-[0.78rem] md:text-[0.84rem] font-bold text-ink whitespace-nowrap overflow-hidden text-ellipsis" data-id="element-132">
                                Balances {c.sick}
                                {sm ? ` — ${sm.n}` : ''}
                              </div>
                              <div className="flex flex-wrap gap-1 mt-1 md:mt-1.5" data-id="element-133">
                                {c.sys.map(sys => {
                          let pillClass = '';
                          if (sys === 's1' || sys === 's5') pillClass = 'bg-amber-p text-gold-d border-gold-d/20';else if (sys === 's2' || sys === 's4') pillClass = 'bg-teal-p text-teal-l border-teal-l/20';else if (sys === 's3') pillClass = 'bg-red-p text-red border-red/20';
                          return <span key={sys} className={`font-mono text-[0.55rem] md:text-[0.59rem] font-bold py-0.5 px-1.5 md:px-2 rounded-md whitespace-nowrap border ${pillClass}`} data-id="element-134">
                                      {SYS_LABEL[sys]}
                                    </span>;
                        })}
                              </div>
                            </div>
                          </div>;
                })}

                      {r.misses.length > 0 && <div className="mt-2 pt-2 border-t border-dashed border-border text-[0.62rem] md:text-[0.67rem] text-muted italic" data-id="element-135">
                          Does not balance:{' '}
                          {r.misses.map((a, i) => <Fragment key={a} data-id="element-136">
                              <span className="font-bold text-red not-italic" data-id="element-137">
                                {a}
                              </span>
                              {i < r.misses.length - 1 ? ', ' : ''}
                            </Fragment>)}
                        </div>}
                    </div>
                  </div>;
          })}
            </div>
          </div>;
    })}

      {to[0] < n && <div className="bg-amber-p border border-[#d4a060] border-l-[4px] border-l-amber rounded-r-[10px] py-3 px-3 md:py-3.5 md:px-4 mt-4 md:mt-5 text-[0.78rem] md:text-[0.82rem] text-amber leading-[1.55]" data-id="element-138">
          <strong className="block text-[0.56rem] md:text-[0.6rem] tracking-[0.07em] uppercase mb-1" data-id="element-139">
            No Single Meridian Covers All {n}
          </strong>
          No single balancing meridian addresses all {n} selected meridians
          simultaneously. Best candidates above cover {to[0]} of {n}. Remove the
          least acute meridian and search again for a fuller match.
        </div>}
    </div>;
}